import EntityList from '../utils/EntityList'

import cpkPalette from './palettes/cpkPalette'
import jmolPalette from './palettes/jmolPalette'
import vmdPalette from './palettes/vmdPalette'

const palettes = new EntityList([cpkPalette, jmolPalette, vmdPalette])

export default palettes
